import { setActionStatusPending, setActionStatusSuccess, setActionStatusError } from '@/store/helpers';

/** @type {import('vuex').MutationTree<typeof import('./state')>} */
export default {
  setActionStatusPending,
  setActionStatusSuccess,
  setActionStatusError
};